import Vue from 'vue';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import App from './App.vue';

import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);
Vue.use(VueRouter);

// Dynamisches Laden der Komponenten
const Home = () => import('./components/Home.vue');
const Impressum = () => import('./components/Impressum.vue');
const Profile = () => import('./components/Profile.vue');
const ThankYou = () => import('./components/ThankYou.vue');
const Stats = () => import('./components/Stats.vue');
//const Thermal = () => import('./components/Thermal.vue');

const routes = [
  { path: '/', component: Home, name: 'home' },
  { path: '/impressum', component: Impressum, name: 'impressum' },
  { path: '/profile', component: Profile, name: 'profile' },
  { path: '/thankyou', component: ThankYou, name: 'thankyou' },
  { path: '/visitors', component: Stats, name: 'visitors' },
  //{ path: '/thermal', component: Thermal, name: 'thermal' },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

new Vue({
  vuetify: new Vuetify(),
  router,
  render: (h) => h(App),
}).$mount('#app');
